import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHourglassEnd,
  faMobile,
  faPlusSquare,
  faGift,
} from "@fortawesome/free-solid-svg-icons";

const HIWC = () => (
  <section id="hiwc" className="section hiwc" aria-labelledby="hiwc-title">
    <div className="hiwc__container">
      <div className="hiwc__media">
        <img src="/images/hiwc.jpg" alt="Illustration — Comment ça marche" />
      </div>

      <div className="hiwc__content">
        <h2 id="hiwc-title" className="hiwc__title">Comment ça marche pour vos clients ?</h2>

        <div className="hiwc__step hiwc__step--1">
          <FontAwesomeIcon icon={faMobile} className="hiwc__icon" aria-hidden="true" />
          <div className="hiwc__step-body">
            <div className="hiwc__step-title">
              <h3>1. Ils téléchargent l'application et créent un compte</h3>
              <div className="hiwc__step-meta">
                <FontAwesomeIcon icon={faHourglassEnd} className="hiwc__meta-icon" aria-hidden="true" />
                <time className="hiwc__duration" dateTime="PT5M">5 min</time>
              </div>
            </div>
            <p className="hiwc__step-desc">
              L'application Carte Verte est disponible sur Google Play et
              l'App Store gratuitement. La création de compte ne nécessite que
              les informations basiques.
            </p>
          </div>
        </div>

        <div className="hiwc__step hiwc__step--2">
          <FontAwesomeIcon icon={faPlusSquare} className="hiwc__icon" aria-hidden="true" />
          <div className="hiwc__step-body">
            <div className="hiwc__step-title">
              <h3>2. Ils ajoutent votre carte de fidélité</h3>
              <div className="hiwc__step-meta">
                <FontAwesomeIcon icon={faHourglassEnd} className="hiwc__meta-icon" aria-hidden="true" />
                <time className="hiwc__duration" dateTime="PT1M">1 min</time>
              </div>
            </div>
            <p className="hiwc__step-desc">
              Vos clients peuvent trouver votre commerce sur l'application Carte
              Verte en recherchant par nom ou adresse et ainsi ajouter votre
              carte à leurs portefeuilles virtuels.
            </p>
          </div>
        </div>

        <div className="hiwc__step hiwc__step--3">
          <FontAwesomeIcon icon={faGift} className="hiwc__icon" aria-hidden="true" />
          <div className="hiwc__step-body">
            <div className="hiwc__step-title">
              <h3>3. Ils commencent à profiter des avantages de fidélité</h3>
              <div className="hiwc__step-meta">
                <FontAwesomeIcon icon={faHourglassEnd} className="hiwc__meta-icon" aria-hidden="true" />
                <span className="hiwc__duration">instantanément</span>
              </div>
            </div>
            <p className="hiwc__step-desc">
              Au passage dans votre magasin, et suite à un achat, vos clients
              peuvent scanner le code QR présenté sur votre smartphone/tablette,
              et ainsi cumuler des tampons virtuels. À mesure que la carte est
              complétée (10, 11 ou 15 tampons), ils peuvent profiter de
              l'avantage que vous leur offrez.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default HIWC;
